const config = {
	drawerWidth: 250,
	topbarHeight: 64,
};

export default config;
